import api from './apiConfig';

export const fetchBrands = async () => {
  try {
    const response = await api.get('marques.php');
    return response.data;
  } catch (error) {
    console.error('Error fetching brands:', error);
    return [];
  }
};

export const fetchCategories = async () => {
  try {
    const response = await api.get('categories.php');
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    return [];
  }
};

export const fetchBsgCode = async () => {
  try {
    const response = await api.get('bsgcod.php');
    return response.data;
  } catch (error) {
    console.error('Error fetching BSG code:', error);
    return [];
  }
};

export const apiService = {
  fetchBrands,
  fetchCategories,
  fetchBsgCode
};
